var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-note"},[_vm._t("product-note-container")],2)}
var staticRenderFns = []

export { render, staticRenderFns }